import { createJournal } from '../journal';

import { TvpilJournalCategory } from './categories';
import { TvpilJournalEvent } from './events';

export const tvpilJournal = createJournal<TvpilJournalEvent, TvpilJournalCategory>();
